import { c as _c } from "react/compiler-runtime";
import { Modal, toast } from '@systemeio/ui';
import { ConnectInfoIntegration } from 'modules/profile/integrations/components/connect-info-integration';
import { ItemIntegration } from 'modules/profile/integrations/components/item-integration';
import { WrapperIntegration } from 'modules/profile/integrations/components/wrapper-integration';
import { WrapperIntegrationSkeleton } from 'modules/profile/integrations/components/wrapper-integtation-skeleton';
import { getHelpPageLinkZoom } from 'modules/profile/integrations/utils/get-help-page-link-zoom';
import { useIntegration } from 'modules/profile/integrations/zoom/hook/use-integration';
import { useIntegrations } from 'modules/profile/integrations/zoom/hook/use-integrations';
import React, { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { ZoomIntegrationIcon } from '@systemeio/ui/icons';
export const ZoomIntegrationComingSoon = () => {
  const $ = _c(8);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ZoomIntegrationIcon />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("dashboard.user_settings.integrations_page.zoom_integration.name");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("dashboard.user_settings.integrations_page.zoom_integration.subtitle");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <WrapperIntegration icon={t0} title={t1} subTitle={t2} isComingSoon={true} />;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export const ZoomIntegration = () => {
  const $ = _c(19);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {
    openZoomLogin,
    removeIntegration
  } = useIntegration({
    onError: handleIntegrationError,
    onSuccess: handleIntegrationSuccess,
    setIsLoading
  });
  const {
    data,
    mutate
  } = useIntegrations();
  async function handleIntegrationSuccess() {
    await mutate();
  }
  let t0;
  if ($[0] !== mutate || $[1] !== removeIntegration) {
    t0 = async function handleIntegrationRemove() {
      ;
      try {
        setIsLoading(true);
        await removeIntegration();
        await mutate();
        setIsLoading(false);
        setOpened(false);
      } catch (t1) {
        const e = t1;
        throw e;
      }
    };
    $[0] = mutate;
    $[1] = removeIntegration;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleIntegrationRemove = t0;
  function handleIntegrationError(error) {
    toast.error(error.message);
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function handleOpenModal() {
      setOpened(true);
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleOpenModal = t1;
  let t2;
  if ($[4] !== openZoomLogin) {
    t2 = async function handleOpenZoomLogin() {
      await openZoomLogin();
      setOpened(false);
    };
    $[4] = openZoomLogin;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleOpenZoomLogin = t2;
  let t3;
  if ($[6] !== handleIntegrationRemove) {
    t3 = async function handleRemoveZoomIntegration() {
      await handleIntegrationRemove();
      setOpened(false);
    };
    $[6] = handleIntegrationRemove;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleRemoveZoomIntegration = t3;
  let t4;
  if ($[8] !== data || $[9] !== handleOpenZoomLogin || $[10] !== handleRemoveZoomIntegration || $[11] !== isLoading || $[12] !== opened || $[13] !== t || $[14] !== user?.dashboardLocale || $[15] !== user?.dateFormat || $[16] !== user?.timeFormat || $[17] !== user?.timezone) {
    t4 = <>{data ? <><WrapperIntegration icon={<ZoomIntegrationIcon />} title={t("dashboard.user_settings.integrations_page.zoom_integration.name")} subTitle={t("dashboard.user_settings.integrations_page.zoom_integration.subtitle")} onClick={handleOpenModal} isConnect={data.items.length !== 0} /><Modal title={t("dashboard.user_settings.integrations_page.zoom_integration_title")} onClose={() => setOpened(false)} opened={opened} isFetching={isLoading}><>{data.items.length !== 0 ? data.items.map(item => <ItemIntegration key={item.id} email={item.email} status={item.status && t("global.active")} createdAt={dateTimeFormat(item.createdAt, {
              timeFormat: user?.timeFormat,
              dateFormat: user?.dateFormat,
              timeZone: user?.timezone
            })} removeIntegration={handleRemoveZoomIntegration} />) : <ConnectInfoIntegration isFetching={isLoading} href={getHelpPageLinkZoom(user?.dashboardLocale)} handleOpenIntegrationLogin={handleOpenZoomLogin} infoText="dashboard.user_settings.integrations_page.zoom_integration_help" />}</></Modal></> : <WrapperIntegrationSkeleton />}</>;
    $[8] = data;
    $[9] = handleOpenZoomLogin;
    $[10] = handleRemoveZoomIntegration;
    $[11] = isLoading;
    $[12] = opened;
    $[13] = t;
    $[14] = user?.dashboardLocale;
    $[15] = user?.dateFormat;
    $[16] = user?.timeFormat;
    $[17] = user?.timezone;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
};